const ITEM_W   = 44;   // mobile swatch: 32px + 12px gap
const SLIDE_W_D = 120; // desktop slide width px
const GAP_D     = 40;  // desktop gap px
const ITEM_W_D  = SLIDE_W_D + GAP_D; // = 160 — stride between slide centers
const ANIM_DUR = 380;  // ms — shared animation duration

const SWATCH_MAP = {
  'Obsidian Black': "#232323",
  'Signature Blue': "#2056BD",
  'Platinum Silver': "#8F8F8F",
  'Olympian Gold': "#BCA986",
  'Pleasantly Purple': "#682984",
  'Money Green': "#1F543E",
  'Moon Rock Red': "#912626",
  'Onyx Black': '#232323',
  'Pearl White': '#F1F1F1',
  "Jasper's Blue": '#164BB5',
  "Purple Poison": '#78108F',
  "Fire Truck Red": '#CF251D',
  "Electric Orange": '#FF7022',
  "Hot AF Pink": '#DF3E7A',
  "Oh Baby Pink": '#F1A6D9',
  "Sunshine Yellow": '#FDE600',
  "Envy Green": '#018a35',
};

// ─── Default text strings ─────────────────────────────────────────────────────

const TEXT_DEFAULTS = {
  step1Title:            'Select base color',
  step2Title:            'Select pop filter',
  step1Ruler:            'STEP 1',
  step2Ruler:            'STEP 2',
  step3Ruler:            'STEP 3',
  price:                 '$165',
  btnSelect:             'Select',
  btnBack:               'Back',
  btnAddToBag:           'Add to bag',
  btnUpdateBag:          'Update bag',
  productPanelTitle:     'Select Kaotica Series',
  productPanelSubtitle:  'Find the Right Kaotica Series for Your Mic',
  btnMicCheck:           'Microphone search',
  noProducts:            'No products found for this color combination.',
  modalTitleMobile:      'Find your mic',
  modalSubtitleMobile:   'Select your microphone',
  modalTitleDesktop:     'Mic search',
  modalSubtitleDesktop:  'Find your Kaotica',
  modalDesktopLabel:     'Select your microphone',
  modalInputPlaceholder: 'Type mic here',
  modalConfirm:          'Confirm',
  modalAddToBag:         'Add to bag',
  modalPreviewTitle:     'Model that fits your microphone',
};

// ─── Icons ────────────────────────────────────────────────────────────────────

const ICON_FORWARD = `<svg class="ksv2-icon-forward" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.68 4.8L0 1.12L1.12 0L5.92 4.8L1.12 9.6L0 8.48L3.68 4.8Z" fill="white"/></svg>`;
const ICON_BACK    = `<svg class="ksv2-icon-back" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.24004 4.79998L5.92004 8.47998L4.80004 9.59998L4.34494e-05 4.79998L4.80004 -2.46976e-05L5.92004 1.11998L2.24004 4.79998Z" fill="#2140B5"/></svg>`;
const ICON_CART    = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_3615_20283" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
<rect width="16" height="16" fill="currentColor"/>
</mask>
<g mask="url(#mask0_3615_20283)">
<path d="M3.33333 14.6667C2.96667 14.6667 2.65278 14.5362 2.39167 14.2751C2.13056 14.014 2 13.7001 2 13.3334V5.33342C2 4.96675 2.13056 4.65286 2.39167 4.39175C2.65278 4.13064 2.96667 4.00008 3.33333 4.00008H4.66667C4.66667 3.07786 4.99167 2.29175 5.64167 1.64175C6.29167 0.991748 7.07778 0.666748 8 0.666748C8.92222 0.666748 9.70833 0.991748 10.3583 1.64175C11.0083 2.29175 11.3333 3.07786 11.3333 4.00008H12.6667C13.0333 4.00008 13.3472 4.13064 13.6083 4.39175C13.8694 4.65286 14 4.96675 14 5.33342V13.3334C14 13.7001 13.8694 14.014 13.6083 14.2751C13.3472 14.5362 13.0333 14.6667 12.6667 14.6667H3.33333ZM3.33333 13.3334H12.6667V5.33342H3.33333V13.3334ZM8 9.33342C8.92222 9.33342 9.70833 9.00842 10.3583 8.35842C11.0083 7.70842 11.3333 6.9223 11.3333 6.00008H10C10 6.55564 9.80556 7.02786 9.41667 7.41675C9.02778 7.80564 8.55556 8.00008 8 8.00008C7.44444 8.00008 6.97222 7.80564 6.58333 7.41675C6.19444 7.02786 6 6.55564 6 6.00008H4.66667C4.66667 6.9223 4.99167 7.70842 5.64167 8.35842C6.29167 9.00842 7.07778 9.33342 8 9.33342ZM6 4.00008H10C10 3.44453 9.80556 2.9723 9.41667 2.58341C9.02778 2.19453 8.55556 2.00008 8 2.00008C7.44444 2.00008 6.97222 2.19453 6.58333 2.58341C6.19444 2.9723 6 3.44453 6 4.00008Z" fill="currentColor"/>
</g>
</svg>
`;

// ─── Helpers ──────────────────────────────────────────────────────────────────

const esc = (str) =>
  String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const filterAndSort = (arr) =>
  (arr || [])
    .filter((item) => item.visible !== false)
    .sort((a, b) => (a.order || 0) - (b.order || 0));

const addToCart = (productLink, properties, editMode) => {
  const match = (productLink || '').match(/[?&]variant=(\d+)/);
  if (!match) { window.location.href = productLink; return; }
  const variantId = parseInt(match[1], 10);
  const qty       = editMode?.qty || 1;

  const doAdd = () =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: properties || {} }] }),
    })
      .then(() => { window.location.href = '/cart'; })
      .catch(() => { window.location.href = productLink; });

  if (editMode?.lineItemKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: editMode.lineItemKey, quantity: 0 }),
    }).then(doAdd).catch(doAdd);
  } else {
    doAdd();
  }
};

const htmlDots = (currentStep) =>
  [1, 2, 3].map((n) => {
    let cls = 'ksv2-step-dot';
    if (n < currentStep)   cls += ' ksv2-step-dot--done';
    if (n === currentStep) cls += ' ksv2-step-dot--active';
    return `<span class="${cls}">${n}</span>`;
  }).join('');

// ─── KaoticaStepperV2 ─────────────────────────────────────────────────────────

class KaoticaStepperV2 {
  constructor(containerSelector, { data, texts = {}, handle = null }) {
    this.el = document.querySelector(containerSelector);
    if (!this.el) return;

    this._initTexts(texts);

    this.baseColors      = filterAndSort(data.baseColors);
    this.popfilterColors = filterAndSort(data.popfilterColors);
    this.microphoneTypes = filterAndSort(data.microphoneTypes);
    this.comboPreviews   = data.basePopfilterCombinations || [];
    this.combinations    = (data.combinations || []).filter((c) => c.visible !== false);
    this.microphones     = (data.microphones  || []).filter((m) => m.visible !== false).sort((a, b) => {
      if ((b.priority || 0) !== (a.priority || 0)) return (b.priority || 0) - (a.priority || 0);
      return (a.name || '').localeCompare(b.name || '');
    });

    this.state = {
      step:                1,
      baseColorIndex:      0,
      popfilterColorIndex: 0,
      productIndex:        0,
    };

    this._initFromHandle(handle);

    // Mobile slider state
    this._sliderVirtual   = 0;
    this._sliderN         = 0;
    this._sliderWrapTimer = null;

    // Desktop slider state
    this._dVirtual   = 0;
    this._dN         = 0;
    this._dWrapTimer = null;
    this._dDragging  = false;
    this._dDragInit  = false;

    // Edit mode — set by _initEditMode if ?edit= param is present
    this._editMode = null;

    this._buildDOM();
    this._showColorPanel(null);
    this._initResizeHandler();
    this._initEditMode();
    this._initImageSwipe();
    this._preloadImages();
  }

  // ─── Text initialisation ──────────────────────────────────────────────────────
  // null/undefined in `texts` → use default; "" → render nothing (node skipped)

  _initTexts(texts) {
    this._t = {};
    for (const key of Object.keys(TEXT_DEFAULTS)) {
      const v = texts[key];
      this._t[key] = (v === null || v === undefined) ? TEXT_DEFAULTS[key] : v;
    }
  }

  // ─── Handle-based color pre-selection ────────────────────────────────────────

  _initFromHandle(handle) {
    if (!handle) return;
    const parts = handle.toLowerCase().split('-');
    const COLOR_KEYWORDS = ['black', 'blue', 'silver', 'gold', 'purple', 'green', 'red'];
    for (const keyword of COLOR_KEYWORDS) {
      if (!parts.includes(keyword)) continue;
      const re = new RegExp(keyword, 'i');
      const idx = this.baseColors.findIndex((c) => re.test(c.title));
      if (idx >= 0) { this.state.baseColorIndex = idx; return; }
    }
  }

  // ─── Build persistent DOM (called once) ───────────────────────────────────────

  _buildDOM() {
    const t = this._t;
    const rulerLabel = (txt) => txt ? `<span class="ksv2-ruler-label">${esc(txt)}</span>` : '';
    const hrulerLabel = (txt) => txt ? `<span class="ksv2-hruler-label">${esc(txt)}</span>` : '';

    this.el.innerHTML = `
      <div class="ksv2">
        <div class="ksv2-background ksv2-square-bg"></div>
        <div class="ksv2-background ksv2-mic-bottom">
          <img src="https://cdn.shopify.com/s/files/1/0796/8903/files/mic-bottom.png?v=1775211447"/>
        </div>
        <div class="ksv2-background ksv2-mic-top">
          <img src="https://cdn.shopify.com/s/files/1/0796/8903/files/test-mic-top.png?v=1775212391"/>
        </div>

        <div class="ksv2-color-panel">
          <p class="ksv2-color-panel-title"></p>
          <div class="ksv2-step-dots"></div>

          <!-- Mobile: single main image -->
          <div class="ksv2-image-stage">
            <img class="ksv2-main-image" src="" alt="" />
          </div>

          <!-- Desktop: infinite image slider (two persistent tracks, one per step) -->
          <div class="ksv2-desktop-slider" style="display:none">
            <div class="ksv2-slider-viewport">
              <div class="ksv2-slider-track" data-track-step="1" style="display:none"></div>
              <div class="ksv2-slider-track" data-track-step="2" style="display:none"></div>
            </div>
          </div>

          <div class="ksv2-color-name"></div>
          <div class="ksv2-dots-row" style="display:none"></div>
          <div class="ksv2-swatches" style="display:none"><div class="ksv2-swatches-track"></div></div>
        </div>

        <div class="ksv2-product-panel" hidden>
          <div class="ksv2-step-dots"></div>
          <div class="ksv2-product-body"></div>
        </div>

        <div class="ksv2-nav"></div>

        <!-- Step indicator (desktop only) -->
        <div class="ksv2-hruler">
          <div class="ksv2-hruler-step ksv2-hruler-step--active" data-step="1">
            <div class="ksv2-hruler-tick"></div>
            ${hrulerLabel(t.step1Ruler)}
          </div>
          <div class="ksv2-hruler-empty"></div>
          <div class="ksv2-hruler-step" data-step="2">
            <div class="ksv2-hruler-tick"></div>
            ${hrulerLabel(t.step2Ruler)}
          </div>
          <div class="ksv2-hruler-empty"></div>
          <div class="ksv2-hruler-step" data-step="3">
            <div class="ksv2-hruler-tick"></div>
            ${hrulerLabel(t.step3Ruler)}
          </div>
        </div>

        <!-- Step ruler (mobile only) -->
        <div class="ksv2-ruler-wrap">
          <div class="ksv2-ruler">
            <div class="ksv2-ruler-row ksv2-ruler-row--active" data-step="1">
              <span class="ksv2-ruler-tick"></span>
              ${rulerLabel(t.step1Ruler)}
              <span class="ksv2-ruler-bar"></span>
            </div>
            <div class="ksv2-ruler-sep"><span class="ksv2-ruler-tick"></span></div>
            <div class="ksv2-ruler-row" data-step="2">
              <span class="ksv2-ruler-tick"></span>
              ${rulerLabel(t.step2Ruler)}
              <span class="ksv2-ruler-bar"></span>
            </div>
            <div class="ksv2-ruler-sep"><span class="ksv2-ruler-tick"></span></div>
            <div class="ksv2-ruler-row" data-step="3">
              <span class="ksv2-ruler-tick"></span>
              ${rulerLabel(t.step3Ruler)}
              <span class="ksv2-ruler-bar"></span>
            </div>
          </div>
        </div>

        <!-- Desktop slider arrows — at root level for free positioning -->
        <button class="ksv2-slider-arrow ksv2-slider-arrow--prev" data-dir="prev" style="display:none">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.24 11.2001L13.92 14.8801L12.8 16.0001L8.00004 11.2001L12.8 6.4001L13.92 7.5201L10.24 11.2001Z" fill="#2140B5"/></svg>
        </button>
        <button class="ksv2-slider-arrow ksv2-slider-arrow--next" data-dir="next" style="display:none">
          <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:scaleX(-1)"><path d="M10.24 11.2001L13.92 14.8801L12.8 16.0001L8.00004 11.2001L12.8 6.4001L13.92 7.5201L10.24 11.2001Z" fill="#2140B5"/></svg>
        </button>
      </div>`;

    this._colorPanel   = this.el.querySelector('.ksv2-color-panel');
    this._productPanel = this.el.querySelector('.ksv2-product-panel');
    this._nav          = this.el.querySelector('.ksv2-nav');
    this._dSlider      = this.el.querySelector('.ksv2-desktop-slider');
    this._rulerWrap    = this.el.querySelector('.ksv2-ruler-wrap');
    this._ruler        = this.el.querySelector('.ksv2-ruler');
    this._hRuler       = this.el.querySelector('.ksv2-hruler');
  }

  // ─── Step ruler (mobile) ──────────────────────────────────────────────────────

  _updateRuler(step) {
    // Mobile: vertical sliding ruler
    if (this._ruler) {
      const activeRow = this._rulerWrap.querySelector(`.ksv2-ruler-row[data-step="${step}"]`);
      const offset = activeRow ? activeRow.offsetTop : 0;
      this._ruler.style.transition = `transform ${ANIM_DUR}ms ease`;
      this._ruler.style.transform  = `translateY(${-offset}px)`;
      this._rulerWrap.querySelectorAll('.ksv2-ruler-row').forEach((row) => {
        row.classList.toggle('ksv2-ruler-row--active', +row.dataset.step === step);
      });
    }

    // Desktop: horizontal static indicator — just swap active class
    if (this._hRuler) {
      this._hRuler.querySelectorAll('.ksv2-hruler-step').forEach((s) => {
        s.classList.toggle('ksv2-hruler-step--active', +s.dataset.step === step);
      });
    }
  }

  // ─── Desktop detection ────────────────────────────────────────────────────────

  _isDesktop() {
    return window.innerWidth >= 989;
  }

  // ─── Resize handler ───────────────────────────────────────────────────────────

  _initResizeHandler() {
    let _wasDesktop = this._isDesktop();
    let _resizeTimer = null;

    window.addEventListener('resize', () => {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(() => {
        const nowDesktop = this._isDesktop();
        if (nowDesktop === _wasDesktop) return;
        _wasDesktop = nowDesktop;

        this._dDragInit = false;
        this.el.querySelectorAll('.ksv2-slider-track').forEach((t) => { t._built = false; });
        document.querySelector('.ksv2-modal')?.remove();

        if (this.state.step === 3) {
          this._colorPanel.hidden         = true;
          this._colorPanel.style.opacity  = '';
          this._colorPanel.style.transition = '';
          this._dSlider.style.display     = 'none';
          this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = 'none');
          this._rulerWrap.style.display   = nowDesktop ? 'none' : '';
          this._productPanel.removeAttribute('hidden');
          this._productPanel.style.position   = '';
          this._productPanel.style.top        = '';
          this._productPanel.style.left       = '';
          this._productPanel.style.width      = '';
          this._productPanel.style.zIndex     = '';
          this._productPanel.style.opacity    = '';
          this._productPanel.style.transform  = '';
          this._productPanel.style.transition = '';
          this._updateProductPanel();
          this._nav.innerHTML = this._htmlProductNav();
          this._bindNavEvents();
          this._updateRuler(3);
        } else {
          this._showColorPanel(null);
        }
      }, 150);
    });
  }

  // ─── Edit mode (URL param ?edit=<lineItemKey>&qty=<n>) ───────────────────────

  _initEditMode() {
    const params      = new URLSearchParams(window.location.search);
    const lineItemKey = params.get('edit');
    const qty         = parseInt(params.get('qty'), 10) || 1;
    if (!lineItemKey) return;

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const item = (cart.items || []).find((i) => i.key === lineItemKey);
        if (!item) return;

        const props    = item.properties || {};
        const baseColor   = props._base_color;
        const popFilter   = props._pop_filter;
        const seriesType  = props._kaotica_series;

        const baseColorIndex = this.baseColors.findIndex((c) => c.title === baseColor);
        if (baseColorIndex < 0) return;

        const popfilterColorIndex = Math.max(0,
          this.popfilterColors.findIndex((c) => c.title === popFilter)
        );

        this.state.baseColorIndex      = baseColorIndex;
        this.state.popfilterColorIndex = popfilterColorIndex;
        this.state.step                = 1;

        const products   = this._getProducts();
        const micType    = this.microphoneTypes.find((t) => t.type === seriesType);
        const productIdx = micType
          ? Math.max(0, products.findIndex((p) => p.microphoneId === micType.uid))
          : 0;
        this.state.productIndex = productIdx;

        this._editMode = { lineItemKey, qty };
        this._showColorPanel(null);
      })
      .catch(() => { /* silently ignore — stepper stays on step 1 */ });
  }

  _showProductPanelImmediate() {
    this.el.querySelector('.ksv2-mic-bottom')?.classList.add('ksv2-mic-bottom--hidden');
    this.el.querySelector('.ksv2-mic-top')?.classList.add('ksv2-mic-top--hidden');
    this.el.querySelector('.ksv2-square-bg')?.classList.add('ksv2-square-bg--step3');
    this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = 'none');
    this._dSlider.style.display = 'none';
    this._rulerWrap.style.display = this._isDesktop() ? 'none' : '';

    this._colorPanel.hidden           = true;
    this._colorPanel.style.opacity    = '';
    this._colorPanel.style.transition = '';

    this._productPanel.removeAttribute('hidden');
    this._productPanel.style.opacity    = '1';
    this._productPanel.style.transform  = '';
    this._productPanel.style.transition = '';

    this._updateProductPanel();
    this._updateRuler(3);
    this._nav.innerHTML = this._htmlProductNav();
    this._bindNavEvents();
  }

  // ─── Color panel (steps 1 & 2) ────────────────────────────────────────────────

  _showColorPanel(imageDir) {
    const isStep1 = this.state.step === 1;
    const colors  = isStep1 ? this.baseColors : this.popfilterColors;
    const index   = isStep1 ? this.state.baseColorIndex : this.state.popfilterColorIndex;

    this._colorPanel.querySelector('.ksv2-step-dots').innerHTML = htmlDots(this.state.step);

    // Title: show/hide depending on whether text is set
    const titleEl  = this._colorPanel.querySelector('.ksv2-color-panel-title');
    const titleTxt = isStep1 ? this._t.step1Title : this._t.step2Title;
    if (titleTxt) {
      titleEl.textContent = titleTxt;
      titleEl.hidden = false;
    } else {
      titleEl.hidden = true;
    }

    // mic-top is visible ONLY on step 1
    this.el.querySelector('.ksv2-mic-top')
      ?.classList.toggle('ksv2-mic-top--hidden', !isStep1);

    this._productPanel.hidden = true;
    this._colorPanel.removeAttribute('hidden');
    this._updateRuler(this.state.step);

    const navHTML = this._htmlColorNav(!isStep1);

    if (this._isDesktop()) {
      this._colorPanel.querySelector('.ksv2-image-stage').style.display = 'none';
      this._colorPanel.querySelector('.ksv2-dots-row').style.display    = 'none';
      this._colorPanel.querySelector('.ksv2-swatches').style.display    = 'none';
      this._rulerWrap.style.display = 'none';
      this._showDesktopSlider(colors, index);
      if (imageDir) {
        this._animateNav(navHTML, imageDir);
      } else {
        this._nav.innerHTML = navHTML;
        this._bindNavEvents();
      }
      return;
    }

    // ── Mobile path — reset desktop elements ──
    this._dSlider.style.display = 'none';
    this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = 'none');
    this._rulerWrap.style.display = '';
    this._colorPanel.querySelector('.ksv2-image-stage').style.display = '';

    const newSrc = isStep1
      ? (this.baseColors[this.state.baseColorIndex].imageUrl || '')
      : this._comboPreviewImage();

    this._transitionImage(newSrc, colors[index].title, imageDir);
    this._updateColorContent(colors, index, imageDir);

    if (imageDir) {
      this._animateNav(navHTML, imageDir);
    } else {
      this._nav.innerHTML = navHTML;
      this._bindNavEvents();
    }
  }

  _updateColorContent(colors, index, fadeDir) {
    const colorName = this._colorPanel.querySelector('.ksv2-color-name');
    const dotsRow   = this._colorPanel.querySelector('.ksv2-dots-row');
    const swatches  = this._colorPanel.querySelector('.ksv2-swatches');

    const apply = () => {
      colorName.textContent = colors[index].title;
      if (this.state.step === 1) this._initDots(colors, index);
      else                       this._initSwatchSlider(colors, index);
    };

    if (!fadeDir) { apply(); return; }

    const half = `${ANIM_DUR / 2}ms ease`;
    [colorName, dotsRow, swatches].forEach((el) => {
      el.style.transition = `opacity ${half}`;
      el.style.opacity    = '0';
    });

    setTimeout(() => {
      apply();
      [colorName, dotsRow, swatches].forEach((el) => {
        el.style.opacity = el.style.display === 'none' ? '' : '1';
      });
    }, ANIM_DUR / 2 + 20);
  }

  // ─── Desktop slider ───────────────────────────────────────────────────────────

  _showDesktopSlider(colors, activeIndex) {
    const slider    = this._dSlider;
    const viewport  = slider.querySelector('.ksv2-slider-viewport');
    const colorName = this._colorPanel.querySelector('.ksv2-color-name');

    this._colorPanel.querySelector('.ksv2-image-stage').style.display = 'none';
    this._colorPanel.querySelector('.ksv2-dots-row').style.display    = 'none';
    this._colorPanel.querySelector('.ksv2-swatches').style.display    = 'none';
    slider.style.display = 'block';
    this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = '');

    const isStep1 = this.state.step === 1;
    const stepKey = isStep1 ? 1 : 2;

    const track = viewport.querySelector(`.ksv2-slider-track[data-track-step="${stepKey}"]`);

    const needsBuild = !track._built
      || (!isStep1 && track._builtForBase !== this.state.baseColorIndex);

    if (needsBuild) {
      track._built        = true;
      track._builtForBase = this.state.baseColorIndex;

      track.innerHTML = [0, 1, 2].flatMap(() =>
        colors.map((c, i) => {
          const imgSrc = isStep1
            ? (c.imageUrl || c.backgroundImageUrl || '')
            : this._comboImageForPopIndex(i);
          return `<div class="ksv2-slide" data-real-index="${i}">
            <img src="${esc(imgSrc)}" alt="${esc(c.title)}" draggable="false" />
          </div>`;
        })
      ).join('');

      // Step 1 fires N-colors x 3 concurrent CDN requests on first build — occasionally
      // one fails under that burst. One-shot retry with cache-busting before giving up.
      if (isStep1) {
        track.querySelectorAll('.ksv2-slide img').forEach((img) => {
          const originalSrc = img.getAttribute('src');
          img.onerror = () => {
            img.onerror = () => {
              console.warn('[KaoticaStepperV2] step1 image failed to load after retry', { src: originalSrc });
            };
            const sep = originalSrc.includes('?') ? '&' : '?';
            img.src = `${originalSrc}${sep}_retry=${Date.now()}`;
          };
        });
      }

      track.onclick = (e) => {
        if (this._dDragging) return;
        const slide = e.target.closest('.ksv2-slide');
        if (!slide) return;
        this._desktopGoTo(parseInt(slide.dataset.realIndex, 10));
      };
    }

    viewport.querySelectorAll('.ksv2-slider-track').forEach((t) => {
      t.style.display = t === track ? '' : 'none';
    });

    this._dActiveTrack = track;
    this._dN           = colors.length;
    this._dVirtual     = activeIndex + colors.length;
    clearTimeout(this._dWrapTimer);

    track.querySelectorAll('.ksv2-slide').forEach((s, i) =>
      s.classList.toggle('ksv2-slide--active', i === this._dVirtual)
    );
    this._dPosition(false);
    colorName.textContent = colors[activeIndex].title;

    this.el.querySelectorAll('.ksv2-slider-arrow').forEach((btn) => {
      btn.onclick = () => {
        const n      = this._dN;
        const real   = ((this._dVirtual % n) + n) % n;
        const target = btn.dataset.dir === 'prev' ? (real - 1 + n) % n : (real + 1) % n;
        this._desktopGoTo(target);
      };
    });

    if (!this._dDragInit) this._initDesktopDrag();
  }

  _dPosition(animate) {
    const track = this._dActiveTrack;
    if (!track) return;
    const offset = -(this._dVirtual * ITEM_W_D + SLIDE_W_D / 2);
    track.style.transition = animate ? `transform ${ANIM_DUR}ms ease` : 'none';
    track.style.transform  = `translateX(${offset}px)`;
  }

  _desktopGoTo(realIndex) {
    const n     = this._dN;
    const track = this._dActiveTrack;

    clearTimeout(this._dWrapTimer);
    const realCurrent = ((this._dVirtual % n) + n) % n;
    this._dVirtual = realCurrent + n;
    if (track) {
      track.style.transition = 'none';
      track.style.transform  = `translateX(${-(this._dVirtual * ITEM_W_D + SLIDE_W_D / 2)}px)`;
      track.getBoundingClientRect();
    }

    const newVirtual = [0, 1, 2]
      .map((copy) => copy * n + realIndex)
      .reduce((best, c) => Math.abs(c - this._dVirtual) < Math.abs(best - this._dVirtual) ? c : best);
    this._desktopSnapToVirtual(newVirtual);
  }

  _desktopSnapToVirtual(targetV) {
    const n = this._dN;
    targetV = Math.max(0, Math.min(3 * n - 1, targetV));
    const realIndex = ((targetV % n) + n) % n;

    this._dVirtual = targetV;

    const track = this._dActiveTrack;
    if (track) {
      track.querySelectorAll('.ksv2-slide').forEach((s, i) =>
        s.classList.toggle('ksv2-slide--active', i === targetV)
      );
    }

    this._dPosition(true);

    clearTimeout(this._dWrapTimer);
    this._dWrapTimer = setTimeout(() => {
      const wrapped = realIndex + n;
      this._dVirtual = wrapped;
      if (track) {
        const slides = track.querySelectorAll('.ksv2-slide');
        slides.forEach((s) => { s.style.transition = 'none'; });
        slides.forEach((s, i) => s.classList.toggle('ksv2-slide--active', i === wrapped));
        this._dPosition(false);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          slides.forEach((s) => { s.style.transition = ''; });
        }));
      }
    }, ANIM_DUR + 20);

    this._dUpdateState(realIndex);
  }

  _dUpdateState(realIndex) {
    const isStep1 = this.state.step === 1;
    if (isStep1) this.state.baseColorIndex = realIndex;
    else          this.state.popfilterColorIndex = realIndex;

    const colors    = isStep1 ? this.baseColors : this.popfilterColors;
    const colorName = this._colorPanel.querySelector('.ksv2-color-name');
    if (colorName) colorName.textContent = colors[realIndex].title;
  }

  _initDesktopDrag() {
    this._dDragInit = true;
    const viewport = this._dSlider.querySelector('.ksv2-slider-viewport');

    let pressed = false, startX = 0, startOffset = 0;

    const getTrack = () => this._dActiveTrack;

    const onStart = (clientX) => {
      pressed = true;
      this._dDragging = false;
      startX = clientX;
      startOffset = -(this._dVirtual * ITEM_W_D + SLIDE_W_D / 2);
      const t = getTrack();
      if (t) t.style.transition = 'none';
    };

    const onMove = (clientX) => {
      if (!pressed) return;
      if (Math.abs(clientX - startX) >= 4) this._dDragging = true;
      if (!this._dDragging) return;
      const offset = startOffset + (clientX - startX);
      const t = getTrack();
      if (t) t.style.transform = `translateX(${offset}px)`;
    };

    const onEnd = (clientX) => {
      if (!pressed) return;
      pressed = false;
      const wasDragging = this._dDragging;
      this._dDragging = false;
      if (!wasDragging) return;
      const offset  = startOffset + (clientX - startX);
      const targetV = Math.round((-offset - SLIDE_W_D / 2) / ITEM_W_D);
      this._desktopSnapToVirtual(targetV);
    };

    viewport.addEventListener('mousedown', (e) => { onStart(e.clientX); e.preventDefault(); });
    window .addEventListener('mousemove',  (e) => onMove(e.clientX));
    window .addEventListener('mouseup',    (e) => onEnd(e.clientX));

    viewport.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
    window .addEventListener('touchmove',   (e) => {
      if (this._dDragging) { e.preventDefault(); onMove(e.touches[0].clientX); }
    }, { passive: false });
    window .addEventListener('touchend',    (e) => onEnd(e.changedTouches[0].clientX));
  }

  // ─── Product panel (step 3) ───────────────────────────────────────────────────

  _showProductPanel() {
    this._updateProductPanel();

    this.el.querySelector('.ksv2-mic-bottom')?.classList.add('ksv2-mic-bottom--hidden');
    this.el.querySelector('.ksv2-square-bg')?.classList.add('ksv2-square-bg--step3');
    this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = 'none');

    this._colorPanel.style.transition = `opacity ${ANIM_DUR}ms ease`;
    this._colorPanel.style.opacity    = '0';

    const panel  = this._productPanel;
    const padTop = parseInt(getComputedStyle(this.el.querySelector('.ksv2')).paddingTop, 10) || 26;
    panel.removeAttribute('hidden');
    panel.style.position   = 'absolute';
    panel.style.top        = `${padTop}px`;
    panel.style.left       = '0';
    panel.style.width      = '100%';
    panel.style.zIndex     = '2';
    panel.style.transition = 'none';
    panel.style.opacity    = '0';
    panel.style.transform  = 'translateY(40px)';
    panel.getBoundingClientRect();
    panel.style.transition = `opacity ${ANIM_DUR}ms ease, transform ${ANIM_DUR}ms ease`;
    panel.style.opacity    = '1';
    panel.style.transform  = 'translateY(0)';

    setTimeout(() => {
      this._colorPanel.hidden = true;
      this._colorPanel.style.opacity    = '';
      this._colorPanel.style.transition = '';
      panel.style.position = '';
      panel.style.top      = '';
      panel.style.left     = '';
      panel.style.width    = '';
      panel.style.zIndex   = '';
    }, ANIM_DUR + 50);

    this._updateRuler(3);
    this._animateNav(this._htmlProductNav(), 'forward');
  }

  // Step 3 → step 2
  _showColorPanelFromStep3() {
    const colors = this.popfilterColors;
    const index  = this.state.popfilterColorIndex;

    this._colorPanel.querySelector('.ksv2-step-dots').innerHTML = htmlDots(2);

    const titleEl = this._colorPanel.querySelector('.ksv2-color-panel-title');
    if (this._t.step2Title) {
      titleEl.textContent = this._t.step2Title;
      titleEl.hidden = false;
    } else {
      titleEl.hidden = true;
    }

    this._colorPanel.querySelector('.ksv2-color-name').textContent = colors[index].title;

    if (this._isDesktop()) {
      this._colorPanel.querySelector('.ksv2-image-stage').style.display = 'none';
      this._colorPanel.querySelector('.ksv2-dots-row').style.display    = 'none';
      this._colorPanel.querySelector('.ksv2-swatches').style.display    = 'none';
      this._rulerWrap.style.display = 'none';
      this._showDesktopSlider(colors, index);
    } else {
      this._dSlider.style.display = 'none';
      this.el.querySelectorAll('.ksv2-slider-arrow').forEach((a) => a.style.display = 'none');
      this._rulerWrap.style.display = '';
      this._colorPanel.querySelector('.ksv2-image-stage').style.display = '';
      this._transitionImage(this._comboPreviewImage(), colors[index].title, null);
      this._initSwatchSlider(colors, index);
    }

    this._colorPanel.removeAttribute('hidden');
    this._colorPanel.style.transition = 'none';
    this._colorPanel.style.opacity    = '0';
    this._colorPanel.getBoundingClientRect();
    this._colorPanel.style.transition = `opacity ${ANIM_DUR}ms ease`;
    this._colorPanel.style.opacity    = '1';

    this.el.querySelector('.ksv2-mic-bottom')?.classList.remove('ksv2-mic-bottom--hidden');
    this.el.querySelector('.ksv2-square-bg')?.classList.remove('ksv2-square-bg--step3');

    const padTop = parseInt(getComputedStyle(this.el.querySelector('.ksv2')).paddingTop, 10) || 26;
    this._productPanel.style.position   = 'absolute';
    this._productPanel.style.top        = `${padTop}px`;
    this._productPanel.style.left       = '0';
    this._productPanel.style.width      = '100%';
    this._productPanel.style.zIndex     = '1';
    this._productPanel.style.transition = `opacity ${ANIM_DUR}ms ease`;
    this._productPanel.style.opacity    = '0';

    setTimeout(() => {
      this._productPanel.hidden = true;
      this._productPanel.style.position   = '';
      this._productPanel.style.top        = '';
      this._productPanel.style.left       = '';
      this._productPanel.style.width      = '';
      this._productPanel.style.zIndex     = '';
      this._productPanel.style.opacity    = '';
      this._productPanel.style.transition = '';
      this._productPanel.style.transform  = '';
      this._colorPanel.style.transition   = '';
      this._colorPanel.style.opacity      = '';
    }, ANIM_DUR + 50);

    this._updateRuler(2);
    this._animateNav(this._htmlColorNav(true), 'backward');
  }

  _updateProductPanel() {
    this._productPanel.querySelector('.ksv2-step-dots').innerHTML = htmlDots(3);
    this._productPanel.querySelector('.ksv2-product-body').innerHTML = this._htmlProductsTab();
    this._bindProductEvents();
  }

  // ─── Shared nav ──────────────────────────────────────────────────────────────

  _htmlColorNav(showBack) {
    const priceHtml = this._t.price ? `<span class="ksv2-price">${esc(this._t.price)}</span>` : '';
    const back      = showBack ? `<button class="ksv2-btn-back" data-action="back">${ICON_BACK}${esc(this._t.btnBack)}</button>` : '';
    return `${priceHtml}${back}<button class="ksv2-btn-next" data-action="next">${esc(this._t.btnSelect)}${ICON_FORWARD}</button>`;
  }

  _htmlProductNav() {
    const priceHtml = this._t.price ? `<span class="ksv2-price">${esc(this._t.price)}</span>` : '';
    const label     = this._editMode ? this._t.btnUpdateBag : this._t.btnAddToBag;
    return `
      ${priceHtml}
      <button class="ksv2-btn-back" data-action="back">${ICON_BACK}${esc(this._t.btnBack)}</button>
      <button class="ksv2-btn-add-to-bag" data-action="add-to-bag">${esc(label)}${ICON_FORWARD}</button>`;
  }

  _getLineItemProperties(product) {
    const micType = this._micTypeForProduct(product);
    return {
      _kaotica_series: micType?.type        || '',
      _description:    micType?.description || '',
      _base_color:     this.baseColors[this.state.baseColorIndex]?.title        || '',
      _pop_filter:     this.popfilterColors[this.state.popfilterColorIndex]?.title || '',
    };
  }

  _handleAddToBag() {
    const products = this._getProducts();
    const product  = products[this.state.productIndex];
    if (!product) return;
    addToCart(product.productLink, this._getLineItemProperties(product), this._editMode);
  }

  _animateNav(newHTML, direction) {
    const nav = this._nav;

    if (!direction) {
      nav.innerHTML = newHTML;
      this._bindNavEvents();
      return;
    }

    if (this._isDesktop()) {
      nav.style.transition = `opacity ${ANIM_DUR / 2}ms ease`;
      nav.style.opacity    = '0';
      setTimeout(() => {
        nav.innerHTML     = newHTML;
        this._bindNavEvents();
        nav.style.opacity = '1';
      }, ANIM_DUR / 2 + 20);
      return;
    }

    const exitTo    = direction === 'forward' ? '-100%' : '100%';
    const enterFrom = direction === 'forward' ? '100%'  : '-100%';

    const oldSlide = document.createElement('div');
    oldSlide.className = 'ksv2-nav-slide ksv2-nav-slide--old';
    oldSlide.innerHTML = nav.innerHTML;

    const newSlide = document.createElement('div');
    newSlide.className = 'ksv2-nav-slide';
    newSlide.innerHTML = newHTML;
    newSlide.style.transform = `translateX(${enterFrom})`;

    nav.innerHTML = '';
    nav.appendChild(oldSlide);
    nav.appendChild(newSlide);
    newSlide.getBoundingClientRect();

    const t = `transform ${ANIM_DUR}ms ease`;
    oldSlide.style.transition = t;
    newSlide.style.transition = t;
    oldSlide.style.transform  = `translateX(${exitTo})`;
    newSlide.style.transform  = 'translateX(0)';

    setTimeout(() => {
      nav.innerHTML = newHTML;
      this._bindNavEvents();
    }, ANIM_DUR + 20);
  }

  _bindNavEvents() {
    this._nav.querySelectorAll('[data-action]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.dataset.action === 'next')       this._onNext();
        if (btn.dataset.action === 'back')       this._onBack();
        if (btn.dataset.action === 'add-to-bag') this._handleAddToBag();
      });
    });
  }

  _onNext() {
    if (this.state.step === 1) {
      this.state.step = 2;
      this._showColorPanel('forward');
    } else if (this.state.step === 2) {
      this.state.step = 3;
      const _fwdProducts = this._getProducts();
      this.state.productIndex = Math.min(
        this.state.productIndex,
        Math.max(0, _fwdProducts.length - 1)
      );
      this._showProductPanel();
    }
  }

  _onBack() {
    if (this.state.step === 2) {
      this.state.step = 1;
      this._showColorPanel('backward');
    } else if (this.state.step === 3) {
      this.state.step = 2;
      this._showColorPanelFromStep3();
    }
  }

  // ─── Image slide animation (mobile) ──────────────────────────────────────────

  _transitionImage(newSrc, newAlt, direction) {
    const stage = this._colorPanel.querySelector('.ksv2-image-stage');

    clearTimeout(this._transitionTimer);
    const allImgs = Array.from(stage.querySelectorAll('.ksv2-main-image'));
    allImgs.slice(0, -1).forEach((img) => img.remove());
    const oldImg = stage.querySelector('.ksv2-main-image');
    if (oldImg) { oldImg.style.transition = ''; oldImg.style.marginLeft = ''; }

    if (!direction) {
      if (oldImg) { oldImg.src = newSrc; oldImg.alt = newAlt; }
      return;
    }

    const stageW    = stage.offsetWidth;
    const enterFrom = direction === 'forward' ? -stageW : stageW;
    const exitTo    = direction === 'forward' ?  stageW : -stageW;

    const newImg     = document.createElement('img');
    newImg.className = 'ksv2-main-image';
    newImg.src       = newSrc;
    newImg.alt       = newAlt;
    newImg.style.marginLeft = `${enterFrom}px`;
    stage.appendChild(newImg);
    newImg.getBoundingClientRect();

    const t = `margin-left ${ANIM_DUR}ms ease`;
    if (oldImg) { oldImg.style.transition = t; oldImg.style.marginLeft = `${exitTo}px`; }
    newImg.style.transition = t;
    newImg.style.marginLeft = '0';

    this._transitionTimer = setTimeout(() => {
      if (oldImg) oldImg.remove();
      newImg.style.transition = '';
      newImg.style.marginLeft = '';
    }, ANIM_DUR + 20);
  }

  // ─── Swatch dots (step 1, mobile) ────────────────────────────────────────────

  _initDots(colors, activeIndex) {
    const row    = this._colorPanel.querySelector('.ksv2-dots-row');
    const slider = this._colorPanel.querySelector('.ksv2-swatches');
    row.style.display    = 'flex';
    slider.style.display = 'none';

    row.innerHTML = colors.map((c, i) => {
      const active = i === activeIndex ? ' ksv2-swatch--active' : '';
      return `<button class="ksv2-swatch${active}" data-index="${i}" style="background: ${SWATCH_MAP[esc(c.title)]}" title="${esc(c.title)}"></button>`;
    }).join('');

    row.addEventListener('click', (e) => {
      const btn = e.target.closest('.ksv2-swatch');
      if (!btn) return;
      const index = parseInt(btn.dataset.index, 10);
      this.state.baseColorIndex = index;

      row.querySelectorAll('.ksv2-swatch').forEach((b, i) =>
        b.classList.toggle('ksv2-swatch--active', i === index)
      );

      const colorName = this._colorPanel.querySelector('.ksv2-color-name');
      if (colorName) colorName.textContent = colors[index].title;

      const img = this._colorPanel.querySelector('.ksv2-main-image');
      if (img) img.src = colors[index].imageUrl || '';
    });
  }

  // ─── Swatch slider (step 2, mobile) ──────────────────────────────────────────

  _initSwatchSlider(colors, activeIndex) {
    const row    = this._colorPanel.querySelector('.ksv2-dots-row');
    const slider = this._colorPanel.querySelector('.ksv2-swatches');
    const track  = slider.querySelector('.ksv2-swatches-track');
    row.style.display    = 'none';
    slider.style.display = 'block';
    slider.getBoundingClientRect();

    clearTimeout(this._sliderWrapTimer);
    this._sliderN       = colors.length;
    this._sliderVirtual = activeIndex + colors.length;

    track.innerHTML = [0, 1, 2].flatMap((copy) =>
      colors.map((c, i) => {
        const active = (copy === 1 && i === activeIndex) ? ' ksv2-swatch--active' : '';
        return `<button class="ksv2-swatch${active}" style="background: ${SWATCH_MAP[esc(c.title)]}" data-real-index="${i}" title="${esc(c.title)}"></button>`;
      })
    ).join('');

    this._sliderPosition(false);

    track.addEventListener('click', (e) => {
      const btn = e.target.closest('.ksv2-swatch');
      if (btn) this._sliderGoTo(parseInt(btn.dataset.realIndex, 10));
    });
  }

  _sliderPosition(animate) {
    const track = this._colorPanel.querySelector('.ksv2-swatches-track');
    const offset = -(this._sliderVirtual + 0.5) * ITEM_W;
    track.style.transition = animate ? `transform ${ANIM_DUR}ms ease` : 'none';
    track.style.transform  = `translateX(${offset}px)`;
  }

  _sliderGoTo(realIndex, skipImageUpdate = false) {
    const n       = this._sliderN;
    const current = this._sliderVirtual;
    const track   = this._colorPanel.querySelector('.ksv2-swatches-track');

    const currentCopy = Math.floor(current / n);
    const newVirtual  = [currentCopy - 1, currentCopy, currentCopy + 1]
      .map((copy) => copy * n + realIndex)
      .reduce((best, c) => Math.abs(c - current) < Math.abs(best - current) ? c : best);

    this._sliderVirtual = newVirtual;

    track.querySelectorAll('.ksv2-swatch').forEach((btn, i) =>
      btn.classList.toggle('ksv2-swatch--active', i === newVirtual)
    );

    this._sliderPosition(true);

    clearTimeout(this._sliderWrapTimer);
    this._sliderWrapTimer = setTimeout(() => {
      const wrapped = realIndex + n;
      this._sliderVirtual = wrapped;
      track.querySelectorAll('.ksv2-swatch').forEach((btn, i) =>
        btn.classList.toggle('ksv2-swatch--active', i === wrapped)
      );
      this._sliderPosition(false);
    }, ANIM_DUR + 20);

    this.state.popfilterColorIndex = realIndex;

    const colorName = this._colorPanel.querySelector('.ksv2-color-name');
    if (colorName) colorName.textContent = this.popfilterColors[realIndex].title;

    if (!skipImageUpdate) {
      const img = this._colorPanel.querySelector('.ksv2-main-image');
      if (img) img.src = this._comboPreviewImage();
    }
  }

  // ─── Swipe (mobile, steps 1 & 2) ────────────────────────────────────────────

  _attachSwipe(el, { requireImgY } = {}) {
    if (!el) return;
    let startX = 0, startY = 0, hasMoved = false, validStart = false;
    const THRESHOLD = 40;
    el.addEventListener('touchstart', (e) => {
      if (requireImgY) {
        const img = el.querySelector('.ksv2-main-image');
        if (img) {
          const { top, bottom } = img.getBoundingClientRect();
          validStart = e.touches[0].clientY >= top && e.touches[0].clientY <= bottom;
        } else {
          validStart = false;
        }
      } else {
        validStart = true;
      }
      console.debug('[FIX] swipe touchstart', { el: el.className, requireImgY: !!requireImgY, validStart, y: e.touches[0].clientY });
      if (!validStart) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; hasMoved = false;
    }, { passive: true });
    el.addEventListener('touchmove', () => { if (validStart) hasMoved = true; }, { passive: true });
    el.addEventListener('touchend', (e) => {
      if (!validStart || !hasMoved) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      this._swipeColor(dx < 0 ? 'forward' : 'backward');
    }, { passive: true });
  }

  _initImageSwipe() {
    // requireImgY previously restricted swipe-start to the image's own vertical bounds
    // (144px) inside the taller .ksv2-image-stage (305px), leaving the bottom ~half of
    // the stage unresponsive to swipes. The stage only ever contains the image, so this
    // Y-restriction protected nothing — dropped so the whole stage area is swipeable.
    this._attachSwipe(this._colorPanel.querySelector('.ksv2-image-stage'));
    this._attachSwipe(this._colorPanel.querySelector('.ksv2-dots-row'));
    this._attachSwipe(this._colorPanel.querySelector('.ksv2-swatches'));
  }

  _swipeColor(dir) {
    if (this._isDesktop() || this.state.step > 2) return;

    const isStep1 = this.state.step === 1;
    const colors  = isStep1 ? this.baseColors : this.popfilterColors;
    const n       = colors.length;
    const delta   = dir === 'forward' ? 1 : -1;
    const animDir = dir === 'forward' ? 'backward' : 'forward';

    if (isStep1) {
      const newIndex = (this.state.baseColorIndex + delta + n) % n;
      this._transitionImage(colors[newIndex].imageUrl || '', colors[newIndex].title, animDir);
      this.state.baseColorIndex = newIndex;

      const colorName = this._colorPanel.querySelector('.ksv2-color-name');
      if (colorName) colorName.textContent = colors[newIndex].title;

      const row = this._colorPanel.querySelector('.ksv2-dots-row');
      if (row) row.querySelectorAll('.ksv2-swatch').forEach((b) =>
        b.classList.toggle('ksv2-swatch--active', parseInt(b.dataset.index, 10) === newIndex)
      );
    } else {
      const newIndex = (this.state.popfilterColorIndex + delta + n) % n;
      this._transitionImage(this._comboImageForPopIndex(newIndex), colors[newIndex].title, animDir);
      this._sliderGoTo(newIndex, true);
    }
  }

  _preloadImages() {
    if (!this._imgCache) this._imgCache = [];

    this.baseColors.forEach((c) => {
      if (c.imageUrl) { const img = new Image(); img.src = c.imageUrl; this._imgCache.push(img); }
    });

    this.comboPreviews.forEach((c) => {
      if (c.imageUrl) { const img = new Image(); img.src = c.imageUrl; this._imgCache.push(img); }
    });

    this.baseColors.forEach((c) => {
      if (c.backgroundImageUrl && c.backgroundImageUrl !== c.imageUrl) {
        const img = new Image(); img.src = c.backgroundImageUrl; this._imgCache.push(img);
      }
    });
  }

  // ─── Step 3 – products tab ────────────────────────────────────────────────────

  _htmlProductsTab() {
    const products = this._getProducts();
    const active   = products[this.state.productIndex] || null;
    const micType  = active ? this._micTypeForProduct(active) : null;

    if (!active) {
      return this._t.noProducts ? `<p class="ksv2-no-products">${esc(this._t.noProducts)}</p>` : '';
    }

    const thumbs = products.slice(0, 5).map((p, i) => {
      const t   = this._micTypeForProduct(p);
      const cls = `ksv2-thumb${i === this.state.productIndex ? ' ksv2-thumb--active' : ''}`;
      return `<button class="${cls}" data-product-index="${i}" title="${esc(t?.title)}">
        <img src="${esc(p.imageUrl || '')}" alt="${esc(t?.title)}" />
      </button>`;
    }).join('');

    const imageHTML = `
      <div class="ksv2-product-image-wrap">
        <img class="ksv2-product-image" src="${esc(active.imageUrl || '')}" alt="${esc(micType?.title)}" />
      </div>`;

    const panelTitleHtml    = this._t.productPanelTitle    ? `<p class="ksv2-product-panel-title">${esc(this._t.productPanelTitle)}</p>`       : '';
    const panelSubtitleHtml = this._t.productPanelSubtitle ? `<p class="ksv2-product-panel-subtitle">${esc(this._t.productPanelSubtitle)}</p>` : '';
    const micCheckHtml      = this._t.btnMicCheck          ? `<button class="ksv2-btn-mic-check">${esc(this._t.btnMicCheck)}</button>`          : '';

    if (this._isDesktop()) {
      return `
        ${panelTitleHtml}
        ${panelSubtitleHtml}
        <div class="ksv2-product-layout">
          ${imageHTML}
          <div class="ksv2-product-info">
            <h3 class="ksv2-product-title">${esc(micType?.title)}</h3>
            <p class="ksv2-product-desc">${esc(micType?.description)}</p>
            <div class="ksv2-thumbs">${thumbs}</div>
            ${micCheckHtml}
          </div>
        </div>`;
    }

    return `
      ${panelTitleHtml}
      <div class="ksv2-product-layout">
        ${imageHTML}
        <div class="ksv2-product-info">
          <h3 class="ksv2-product-title">${esc(micType?.title)}</h3>
          <p class="ksv2-product-desc">${esc(micType?.description)}</p>
          ${micCheckHtml}
        </div>
      </div>
      <div class="ksv2-thumbs">${thumbs}</div>`;
  }

  // ─── Event binding – product panel ───────────────────────────────────────────

  _bindProductEvents() {
    const panel = this._productPanel;

    panel.querySelectorAll('.ksv2-thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.state.productIndex = parseInt(thumb.dataset.productIndex, 10);
        this._updateProductPanel();
        this._nav.innerHTML = this._htmlProductNav();
        this._bindNavEvents();
      });
    });

    panel.querySelector('.ksv2-btn-mic-check')?.addEventListener('click', () => {
      this._openMicFitModal();
    });
  }

  // ─── Mic fit check modal ──────────────────────────────────────────────────────

  _openMicFitModal() {
    document.querySelector('.ksv2-modal')?.remove();

    const isDesktop = this._isDesktop();
    const t = this._t;

    let selectedProductIndex = -1;
    let selectedMicUid       = null;
    let listVisible          = true;
    let _userTyped           = false;

    const ICON_SEARCH    = `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_3615_20254" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-1" width="25" height="26">
    <rect y="-0.000366211" width="24.6981" height="24.6981" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_3615_20254)">
    <path d="M20.1739 21.6044L13.6906 15.1211C13.1761 15.5327 12.5844 15.8586 11.9155 16.0987C11.2466 16.3389 10.5348 16.4589 9.78012 16.4589C7.91062 16.4589 6.3284 15.8115 5.03346 14.5165C3.73853 13.2216 3.09106 11.6394 3.09106 9.76987C3.09106 7.90036 3.73853 6.31814 5.03346 5.02321C6.3284 3.72828 7.91062 3.08081 9.78012 3.08081C11.6496 3.08081 13.2318 3.72828 14.5268 5.02321C15.8217 6.31814 16.4692 7.90036 16.4692 9.76987C16.4692 10.5245 16.3491 11.2363 16.109 11.9052C15.8689 12.5741 15.543 13.1658 15.1314 13.6804L21.6146 20.1636L20.1739 21.6044ZM9.78012 14.4008C11.0665 14.4008 12.1599 13.9505 13.0603 13.0501C13.9608 12.1496 14.411 11.0562 14.411 9.76987C14.411 8.48351 13.9608 7.39011 13.0603 6.48966C12.1599 5.58921 11.0665 5.13898 9.78012 5.13898C8.49376 5.13898 7.40036 5.58921 6.49991 6.48966C5.59946 7.39011 5.14924 8.48351 5.14924 9.76987C5.14924 11.0562 5.59946 12.1496 6.49991 13.0501C7.40036 13.9505 8.49376 14.4008 9.78012 14.4008Z" fill="#1C1B1F"/>
    </g>
    </svg>
`;
    const ICON_CHEV_DOWN = `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_3615_20258" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-1" width="25" height="26">
    <rect y="-0.000366211" width="24.6981" height="24.6981" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_3615_20258)">
    <path d="M12.3456 15.4313L7.2002 10.2859H17.4911L12.3456 15.4313Z" fill="#1C1B1F"/>
    </g>
    </svg>
`;
    const ICON_CLOSE     = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.4 9.975L0 8.575L3.6 4.975L0 1.4L1.4 0L5 3.6L8.575 0L9.975 1.4L6.375 4.975L9.975 8.575L8.575 9.975L5 6.375L1.4 9.975Z" fill="#1C1B1F"/></svg>`;

    const modal = document.createElement('div');
    modal.className = 'ksv2-modal';

    const modalTitleHtml    = (txt) => txt ? `<h3 class="ksv2-modal-title">${esc(txt)}</h3>`    : '';
    const modalSubtitleHtml = (txt) => txt ? `<p class="ksv2-modal-subtitle">${esc(txt)}</p>`   : '';
    const modalLabelHtml    = (txt) => txt ? `<p class="ksv2-modal-desktop-label">${esc(txt)}</p>` : '';

    if (isDesktop) {
      modal.innerHTML = `
        <div class="ksv2-modal-backdrop"></div>
        <div class="ksv2-modal-box ksv2-modal-box--desktop">
          <button class="ksv2-modal-close ksv2-modal-close--desktop">${ICON_CLOSE}</button>
          <div class="ksv2-modal-header">
            ${modalTitleHtml(t.modalTitleDesktop)}
            ${modalSubtitleHtml(t.modalSubtitleDesktop)}
          </div>
          <div class="ksv2-modal-desktop-body">
            <div class="ksv2-modal-desktop-left">
              ${modalLabelHtml(t.modalDesktopLabel)}
              <div class="ksv2-modal-search-wrap">
                ${ICON_SEARCH}
                <input class="ksv2-modal-input" type="text" placeholder="${esc(t.modalInputPlaceholder)}" autocomplete="off" />
                ${ICON_CHEV_DOWN}
              </div>
              <ul class="ksv2-modal-list"></ul>
            </div>
            <div class="ksv2-modal-desktop-right">
              <div class="ksv2-modal-preview"></div>
            </div>
          </div>
          <div class="ksv2-modal-footer">
            <button class="ksv2-btn-back ksv2-modal-btn-confirm" disabled>${esc(t.modalConfirm)}</button>
            <button class="ksv2-btn-add-to-bag ksv2-modal-btn-bag" disabled>${esc(t.modalAddToBag)}${ICON_CART}</button>
          </div>
        </div>`;
    } else {
      modal.innerHTML = `
        <div class="ksv2-modal-backdrop"></div>
        <div class="ksv2-modal-box">
          <button class="ksv2-modal-close">${ICON_CLOSE}</button>
          <div class="ksv2-modal-header">
            ${modalTitleHtml(t.modalTitleMobile)}
            ${modalSubtitleHtml(t.modalSubtitleMobile)}
          </div>
          <div class="ksv2-modal-search-wrap">
            ${ICON_SEARCH}
            <input class="ksv2-modal-input" type="text" placeholder="${esc(t.modalInputPlaceholder)}" autocomplete="off" />
            ${ICON_CHEV_DOWN}
          </div>
          <div class="ksv2-modal-body">
            <ul class="ksv2-modal-list"></ul>
            <div class="ksv2-modal-preview"></div>
          </div>
          <div class="ksv2-modal-footer">
            <button class="ksv2-btn-back ksv2-modal-btn-confirm" disabled>${esc(t.modalConfirm)}</button>
            <button class="ksv2-btn-add-to-bag ksv2-modal-btn-bag" disabled>${esc(t.modalAddToBag)}${ICON_CART}</button>
          </div>
        </div>`;
    }

    document.body.appendChild(modal);

    const input      = modal.querySelector('.ksv2-modal-input');
    const list       = modal.querySelector('.ksv2-modal-list');
    const preview    = modal.querySelector('.ksv2-modal-preview');
    const btnConfirm = modal.querySelector('.ksv2-modal-btn-confirm');
    const btnBag     = modal.querySelector('.ksv2-modal-btn-bag');

    const openList = () => {
      listVisible           = true;
      list.style.display    = '';
      preview.style.display = 'none';
    };

    const _renderPreview = (product, micType, enableButtons) => {
      const previewTitleHtml = t.modalPreviewTitle ? `<p class="ksv2-modal-preview-title">${esc(t.modalPreviewTitle)}</p>` : '';
      if (isDesktop) {
        preview.innerHTML = `
          ${previewTitleHtml}
          <div class="ksv2-modal-desktop-preview-img">
            <img class="ksv2-product-image" src="${esc(product.imageUrl || '')}" alt="${esc(micType.title)}" />
          </div>
          <h3 class="ksv2-product-title">${esc(micType.title)}</h3>
          <p class="ksv2-product-desc">${esc(micType.description)}</p>`;
      } else {
        preview.innerHTML = `
          <div class="ksv2-modal-image-bg"></div>
          ${previewTitleHtml}
          <div class="ksv2-product-layout">
            <div class="ksv2-product-image-wrap">
              <img class="ksv2-product-image" src="${esc(product.imageUrl || '')}" alt="${esc(micType.title)}" />
            </div>
            <div class="ksv2-product-info">
              <h3 class="ksv2-product-title">${esc(micType.title)}</h3>
              <p class="ksv2-product-desc">${esc(micType.description)}</p>
            </div>
          </div>`;
        listVisible           = false;
        list.style.display    = 'none';
        preview.style.display = 'block';
      }
      btnConfirm.disabled = !enableButtons;
      btnBag.disabled     = !enableButtons;
    };

    const closeList = () => {
      if (selectedProductIndex !== -1) {
        const products = this._getProducts();
        const product  = products[selectedProductIndex];
        const micType  = product ? this._micTypeForProduct(product) : null;
        if (product && micType) { _renderPreview(product, micType, true); return; }
      }
      const products = this._getProducts();
      const product  = products[this.state.productIndex];
      const micType  = product ? this._micTypeForProduct(product) : null;
      if (product && micType) _renderPreview(product, micType, false);
    };

    const MIC_TYPE_MAP = { 1: 'sevenb', 2: 'eyeball', 3: '800c', 4: 'fatboy', 5: 'live' };
    const showPreview = (micUid) => {
      const mic        = this.microphones.find((m) => m.uid === micUid);
      const typeStr    = mic ? MIC_TYPE_MAP[mic.type] : null;
      const micType    = typeStr ? this.microphoneTypes.find((t) => t.type === typeStr) : null;
      if (!micType) return;

      const products = this._getProducts();
      const idx      = products.findIndex((p) => p.microphoneId === micType.uid);
      if (idx === -1) return;

      const product        = products[idx];
      selectedProductIndex = idx;
      selectedMicUid       = micUid;

      _userTyped = false;

      input.value = `${mic.modelName || ''} ${mic.name || ''}`.trim();
      if (isDesktop) {
        listVisible        = false;
        list.style.display = 'none';
      }

      _renderPreview(product, micType, true);
    };

    const renderList = (q = '') => {
      const filtered = q.trim()
        ? this.microphones.filter((m) =>
            `${m.modelName || ''} ${m.name || ''}`.toLowerCase().includes(q.toLowerCase().trim())
          )
        : this.microphones;

      list.innerHTML = filtered.slice(0, 200).map((m) => {
        const active = m.uid === selectedMicUid ? ' ksv2-modal-item--active' : '';
        return `<li class="ksv2-modal-item${active}" data-mic-uid="${esc(m.uid)}">
          ${esc(`${m.modelName || ''} ${m.name || ''}`.trim())}
        </li>`;
      }).join('');

      list.querySelectorAll('.ksv2-modal-item').forEach((item) => {
        item.addEventListener('click', () => showPreview(item.dataset.micUid));
      });
    };

    const close = () => modal.remove();

    modal.querySelector('.ksv2-modal-close').addEventListener('click', close);
    modal.querySelector('.ksv2-modal-backdrop').addEventListener('click', close);

    const searchWrap = modal.querySelector('.ksv2-modal-search-wrap');

    if (isDesktop) {
      const dOpenList  = () => { listVisible = true;  list.style.display = ''; };
      const dCloseList = () => { listVisible = false; list.style.display = 'none'; };

      let _skipNextFocus = false;
      searchWrap.addEventListener('click', (e) => {
        if (e.target === input) _skipNextFocus = true;
        if (listVisible) { dCloseList(); } else { dOpenList(); renderList(_userTyped ? input.value : ''); }
      });
      input.addEventListener('focus', () => {
        if (_skipNextFocus) { _skipNextFocus = false; return; }
        if (!listVisible) { dOpenList(); renderList(_userTyped ? input.value : ''); }
      });
      input.addEventListener('input', (e) => {
        _userTyped = true;
        if (!listVisible) dOpenList();
        renderList(e.target.value);
      });
    } else {
      let _skipNextFocus = false;
      searchWrap.addEventListener('click', (e) => {
        if (e.target === input) _skipNextFocus = true;
        if (listVisible) { closeList(); } else { openList(); renderList(_userTyped ? input.value : ''); }
      });
      input.addEventListener('focus', () => {
        if (_skipNextFocus) { _skipNextFocus = false; return; }
        if (!listVisible) { openList(); renderList(_userTyped ? input.value : ''); }
      });
      input.addEventListener('input', (e) => {
        _userTyped = true;
        if (!listVisible) openList();
        renderList(e.target.value);
      });
    }

    btnConfirm.addEventListener('click', () => {
      if (selectedProductIndex === -1) return;
      this.state.productIndex = selectedProductIndex;
      this._updateProductPanel();
      this._nav.innerHTML = this._htmlProductNav();
      this._bindNavEvents();
      close();
    });

    btnBag.addEventListener('click', () => {
      if (selectedProductIndex === -1) return;
      const products = this._getProducts();
      const product  = products[selectedProductIndex];
      if (!product) return;
      addToCart(product.productLink, this._getLineItemProperties(product), this._editMode);
    });

    renderList();
    if (isDesktop) {
      requestAnimationFrame(() => {
        const modalBox   = modal.querySelector('.ksv2-modal-box--desktop');
        const leftCol    = modal.querySelector('.ksv2-modal-desktop-left');
        const searchWrap = modal.querySelector('.ksv2-modal-search-wrap');
        const boxRect    = modalBox.getBoundingClientRect();
        const swRect     = searchWrap.getBoundingClientRect();
        const lcRect     = leftCol.getBoundingClientRect();

        list.style.position = 'absolute';
        list.style.top      = (swRect.bottom - boxRect.top) + 'px';
        list.style.left     = (lcRect.left   - boxRect.left) + 'px';
        list.style.width    = lcRect.width + 'px';
        list.style.bottom   = '0';
        list.style.zIndex   = '10';
        list.style.height   = 'auto';
        list.style.margin   = '0';
        modalBox.appendChild(list);
      });

      const products = this._getProducts();
      const product  = products[this.state.productIndex];
      const micType  = product ? this._micTypeForProduct(product) : null;
      if (product && micType) _renderPreview(product, micType, false);
    }
  }

  // ─── Data queries ─────────────────────────────────────────────────────────────

  _comboPreviewImage() {
    return this._comboImageForPopIndex(this.state.popfilterColorIndex);
  }

  _comboImageForPopIndex(popIndex) {
    const baseId = this.baseColors[this.state.baseColorIndex].uid;
    const popId  = this.popfilterColors[popIndex]?.uid;
    const combo  = this.comboPreviews.find((c) => c.baseColorId === baseId && c.popfilterColorId === popId);
    return combo?.imageUrl || this.baseColors[this.state.baseColorIndex].imageUrl || '';
  }

  _getProducts() {
    const baseId = this.baseColors[this.state.baseColorIndex].uid;
    const popId  = this.popfilterColors[this.state.popfilterColorIndex].uid;
    return this.combinations.filter((c) => c.baseColorId === baseId && c.popfilterColorId === popId);
  }

  _micTypeForProduct(product) {
    return this.microphoneTypes.find((t) => t.uid === product.microphoneId) || null;
  }
}

window.KaoticaStepperV2 = KaoticaStepperV2;

// ─── Ripple ───────────────────────────────────────────────────────────────────

document.addEventListener('pointerdown', function (e) {
  const btn = e.target.closest(
    '.ksv2-btn-next, .ksv2-btn-back, .ksv2-btn-cart, .ksv2-btn-add-to-bag, ' +
    '.ksv2-swatch, .ksv2-thumb, .ksv2-slider-arrow'
  );
  if (!btn) return;

  const rect   = btn.getBoundingClientRect();
  const size   = Math.max(rect.width, rect.height) * 2;
  const x      = e.clientX - rect.left - size / 2;
  const y      = e.clientY - rect.top  - size / 2;

  const ripple = document.createElement('span');
  ripple.className = 'ksv2-ripple';
  ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px`;
  btn.appendChild(ripple);
  ripple.addEventListener('animationend', () => ripple.remove());
}, { passive: true });
